import gql from "graphql-tag";

export const MY_TIMESHEET_TIMESHEETS_SUBSCRIPTION = gql`
  subscription mySheetTimesheetSubscription {
    mySheetTimesheetSubscription
  }
`;
